module.exports = __webpack_public_path__ + "img/112.4.7d96d79e.png";